import { useMenuDesignTheme } from '@/services/menu-design'

type ImgProps = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>

/**
 * Отметка «выбрано»: плитки предпочтений, списки блюд, состав заказа.
 * В прежнем оформлении это картинка с зелёным кружком. Растровую картинку
 * не перекрасить, поэтому в новой теме тот же значок рисуем разметкой —
 * лаймовый кружок с чернильной птичкой, как остальные отметки темы.
 */
export function GreenCheckmark(props: ImgProps) {
  const theme = useMenuDesignTheme()

  if (theme === 'modern') {
    return (
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        className={props.className}
        style={props.style}
        width={props.width}
        height={props.height}
      >
        <circle cx="12" cy="12" r="12" fill="var(--action)" />
        <path
          d="M6.5 12.5l3.6 3.6L17.5 8.5"
          fill="none"
          stroke="var(--action-ink)"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  return <img src="/img/components/checkmark/checkmark.png" alt="checkmark" {...props} />
}

export function SlimCheckmark(props: { color: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={props.color}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20 6L9 17L4 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
